<template>
    <div class="h-100 d-flex flex-column">
        <!-- Поле ввода адреса -->

        <div v-if="this.satge === 0">
            <p class="fsp14 neue mbp-8" for="address">{{ $t('components.service.AMLCheck.12') }}</p>
            <div class="provider-grid">
                <div 
                    v-for="(provider, index) in providers" 
                    :key="index"
                    class="provider-item d-flex flex-column align-items-center justify-content-center pp-16"
                    @:click="this.getBlockchains(provider)"
                >
                    <img 
                        :src="provider.img" 
                        :alt="provider.name"
                        class="provider-logo mbp-16"
                    />
                    <span class="fsp20 neue text-center">{{ provider.name }}</span>
                </div>
            </div>
        </div>
        
        <div class="" v-if="this.satge === 1 || this.satge === 2">
            <label class="fsp14 neue mbp-8" for="address">{{ $t('components.service.AMLCheck.1') }}</label>
            <InputSimple
                class="fsp14 neue"
                :iconColor="'#a9a9a9'"
                :icon="this.system_alias_name ? `crypto-${this.system_alias_name}` : 'wallet'"
                type="text" 
                id="address"
                :dataValue="this.data.address"
                :placeholder="$t('components.service.AMLCheck.2')"
                @updateParentState="updateAddress"
            />
        </div>
        
        <!-- Плитка блокчейнов -->
        <div v-if="this.satge === 1" class="flex-grow-1 d-flex flex-column justify-content-between">

        <div>
            <p class="fsp14 neue mbp-8 mtp-32" ref="gridTitle">{{ $t('components.service.AMLCheck.3') }}</p>
            <InputSimple
                id="search-blockchain"
                class="fsp14 neue mb16"
                icon="search-grey"
                :dataValue="this.searchBlockchain"
                :placeholder="`${$t('components.service.TableList.1')}...`"
                @updateParentState="(e) => searchBlockchain = e.value"
            />
            <div class="aml-blockchain-grid" ref="blockchainGrid" :style="{ height: gridHeight + 'px' }">
                <div 
                    v-for="(name) in filteredBlockchains" 
                    :key="name.code"
                    class="aml-blockchain-item d-flex align-items-center neue fsp14"
                    :class="{ 
                        'selected': this.data.system_alias === name.code
                    }"
                    @click="selectBlockchain(name)"
                >
                    <Icon 
                        :name="`crypto-${name.value}`"
                        class="blockchain-icon me-2"
                        :size="'c32'"
                    />
                    <span>{{ name.value }}</span>
                </div>
            </div>
        </div>
        
        <!-- Кнопка проверки -->
        <div class="pt-3 d-flex gap-2 position-fixed bottom-0 left-0 end-0 py16 px24 w-100 bg-white" ref="checkButton">
            <Button 
                @click="back" 
                :name="$t('components.service.AMLCheck.11')" 
                type="btn-outline-grey" 
                class="equal-width" 
            />
            <Button 
                class="equal-width h56"
                type="btn-warning"
                :disabled="!this.data.address || !this.data.system_alias"
                @click="performCheck"
            >
                <Icon name="search-grey" :color="'#ffffff'" class="mrp-8" />
                <span class="neue fsp14">{{ $t('components.service.AMLCheck.4') }}</span>
            </Button>
        </div>

        </div>

        <div v-else-if="this.satge === 2 && this.result">
            <div 
                class="aml-result-message d-flex align-items-center mtp-16"
                :class="{ 'error': this.result.result !== '0' }"
            >
                <Icon 
                    :name="this.result.result === '0' ? 'check-green' : 'info'" 
                    :color="this.result.result !== '0' ? '#FF3B30' : false"
                    class="me-2" 
                />
                <span class="neue fsp14">
                    {{ this.result.result === '0' ? $t('components.service.AMLCheck.8') : this.result.result_text }}
                </span>
            </div>
            <!-- Блок с прогрессбаром -->
            <div v-if="this.result && this.result.result === '0'">
            <div class="d-flex justify-content-center progress-container">
                <div class="progress-circle-container">
                    <svg width="257" height="153" viewBox="0 0 257 153" class="progress-circle">
                        <!-- Фоновая дуга -->
                        <path
                            d="M 25 128.5 A 103.5 103.5 0 1 1 232 128.5"
                            fill="none"
                            stroke="#E5E7EB"
                            stroke-width="16"
                            stroke-linecap="round"
                        />
                        <!-- Прогрессная дуга -->
                        <path
                            d="M 25 128.5 A 103.5 103.5 0 1 1 232 128.5"
                            fill="none"
                            stroke-width="16"
                            stroke-linecap="round"
                            :stroke-dasharray="progressDashArray"
                            :stroke-dashoffset="progressDashOffset"
                            :stroke="progressColor"
                            class="progress-arc"
                        />
                    </svg>
                    <!-- Текст с процентами -->
                    <div class="progress-text">
                        <span class="progress-percentage neue-bold" :style="{ color: progressColor }">{{ Math.round(this.animatedProgress) }}%</span>
                    </div>
                    <!-- Подписи 0 и 100 -->
                    <div class="progress-labels">
                        <span class="label-start">0</span>
                        <span class="label-end">100</span>
                    </div>
                </div>
            </div>
            
            <!-- Текст риска под прогрессбаром -->
            <div class="risk-text neue fsp20" :style="{ color: progressColor }">
                {{ riskText }}
            </div>
            </div>
            
            <!-- Кнопка проверки другого адреса -->
            <div class="btn-container">
                <Button 
                    class="equal-width check-another-btn h56"
                    type="btn-warning"
                    @click="resetCheck"
                >
                    <Icon name="refresh" :color="'#ffffff'" class="mrp-8" />
                    <span class="neue fsp14">{{ $t('components.service.AMLCheck.9') }}</span>
                </Button>
                <Button 
                    v-if="this.pdf"
                    class="equal-width h56"
                    type="btn-outline-grey"
                    @click="downloadPDF"
                    @mouseover="iconHover = 'download-file'"
                    @mouseleave="iconHover = false"
                >
                    <Icon name="download-file" class="mrp-8" :active="iconHover !== 'download-file'" />
                    <span class="neue fsp14">{{ $t('components.service.AMLCheck.10') }}</span>
                </Button>
            </div>
            
        </div>
    </div>
</template>

<script>
import InputSimple from '@/components/service/InputSimple';
import Button from '@/components/service/Button';
import Icon from '@/components/icons/Icon';

export default {
    name: 'AMLCheck',
    components: {
        InputSimple,
        Button,
        Icon
    },
    data() {
        return {
            providers: [],
            blockchains: [],
            selected_blockchain: false,
            system_alias_name: '',
            searchBlockchain: '',
            data: {
                type: 'address',
                system_alias: '',
                address: '',
            },
            aml_type: this.$store.state.config.AML_TYPE,
            satge: 0,
            result: false,
            animatedProgress: 0,
            gridHeight: 300,
            iconHover: false,
            pdf: false
        }
    },
    computed: {
        filteredBlockchains() {
            return this.blockchains.filter(blockchain => blockchain.value.toLowerCase().includes(this.searchBlockchain.toLowerCase()));
        },
        progressDashArray() {
            // Длина полукруга (π * радиус)
            const circumference = Math.PI * 103.5;
            return `${circumference} ${circumference}`;
        },
        progressDashOffset() {
            const circumference = Math.PI * 103.5;
            return circumference - (this.animatedProgress / 100) * circumference;
        },
        progressColor() {
            const progress = Math.round(this.animatedProgress);
            if (progress <= 30) {
                return '#22c55e'; // Зеленый
            } else if (progress <= 69) {
                return '#eab308'; // Желтый
            } else {
                return '#ef4444'; // Красный
            }
        },
        riskText() {
            const progress = Math.round(this.animatedProgress);
            if (progress <= 30) {
                return this.$t('components.service.AMLCheck.5');
            } else if (progress <= 69) {
                return this.$t('components.service.AMLCheck.6');
            } else {
                return this.$t('components.service.AMLCheck.7');
            }
        }
    },
    watch: {
        'result.tables': {
            handler() {
                if (this.result && this.result.tables && this.result.tables[0] && this.result.tables[0].colvalues && this.result.tables[0].colvalues[0]) {
                    this.$nextTick(() => {
                        this.animateProgress();
                    });
                }
            },
            deep: true,
            immediate: true
        }
    }, 
    methods: {
        back() {
            this.satge = 0;
            this.selected_blockchain = false;
            this.blockchains = [];
            this.data = {
                type: 'address',
                system_alias: '',
                address: '',
            },
            this.system_alias_name = '';
            this.$store.commit('SIDE_PANEL_SET_TITLE', '');
        },
        base64ToBlob() {
            const byteCharacters = atob(this.pdf);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], { type: "application/pdf" });
        },
        getBlockchains(arg) {
            this.axios.post('GetFormFields', {data: {payform: arg.code}}).then(res => {
            if (res.data.body.result && res.data.body.result !== '0') {
                return;
            }
            this.blockchains = res.data.body[0]['lists'];
            this.selected_blockchain = arg;
            this.satge = 1;
            this.calculateGridHeight();
            this.$store.commit('SIDE_PANEL_SET_TITLE', `${this.$t('components.service.SidePanel.1')} (${arg.name})`);
        });
        },
        downloadPDF() {
            const blob = this.base64ToBlob(this.pdf);
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `${this.data.system_alias.split(',')[0].toUpperCase()}_${this.data.address}.pdf`;
            link.click();
            URL.revokeObjectURL(link.href);
        },
        updateAddress(data) {
            this.data.address = data.value;
        },
        selectBlockchain(arg) {
            this.data.system_alias = arg.code;
            this.system_alias_name = arg.value;
        },
        performCheck() {
            if (!this.data.address || !this.data.system_alias) {
                return;
            }
            
            let params = {
                type: this.data.type,
                system_alias: this.data.system_alias,
                info: this.setInfo(this.data.address),
                how: this.selected_blockchain.how
            };
            
            this.$store.commit('MODAL', {
                action: true,
                type: 'pay_pass',
                content: {callback: () => {
                    this.axios.post('GetAmlRisk', {data: params}).then(res => {
                        this.result = res.data.body;
                        this.satge = 2;
                        if(this.result.tables[0]?.colvalues[0]) {
                            this.pdf = JSON.parse(this.result.tables[0].colvalues[0].full_data).pdf_report_base64;
                        }
                    });
                }}
            });
        },
        setInfo(address) {
            // console.log(address)
            let res = {
                addresses: [address]
            };
            // console.log(res)
            return JSON.stringify(res);
        },
        animateProgress() {
            if (!this.result || !this.result.tables || !this.result.tables[0] || !this.result.tables[0].colvalues || !this.result.tables[0].colvalues[0]) {
                return;
            }
            
            const targetProgress = parseFloat(this.result.tables[0].colvalues[0].risk);
            const duration = 1000; // 1 секунда
            const startTime = Date.now();
            const startProgress = 0;
            
            const animate = () => {
                const elapsed = Date.now() - startTime;
                const progress = Math.min(elapsed / duration, 1);
                
                // Линейная анимация для ровного заполнения
                this.animatedProgress = startProgress + (targetProgress - startProgress) * progress;
                
                if (progress < 1) {
                    requestAnimationFrame(animate);
                } else {
                    this.animatedProgress = targetProgress;
                }
            };
            
            requestAnimationFrame(animate);
        },
        resetCheck() {
            this.satge = 0;
            this.data.address = '';
            this.data.system_alias = '';
            this.animatedProgress = 0;
            this.selected_blockchain = false;
            this.pdf = false;
            this.$store.commit('SIDE_PANEL_SET_TITLE', '');
        },
        calculateGridHeight() {
            this.$nextTick(() => {
                if (this.$refs.gridTitle && this.$refs.checkButton) {
                    const containerHeight = window.innerHeight;
                    const titleHeight = this.$refs.gridTitle.offsetHeight;
                    const buttonHeight = this.$refs.checkButton.offsetHeight;
                    const inputHeight = 155; // Примерная высота поля ввода с отступами
                    const padding = 150; // Отступы панели и дополнительные отступы
                    
                    this.gridHeight = containerHeight - titleHeight - buttonHeight - inputHeight - padding;
                    
                    // Минимальная высота
                    if (this.gridHeight < 200) {
                        this.gridHeight = 200;
                    }
                }
            });
        }
    },
    created() {
        this.axios.post('GetSearchMomental', {data: {'form_type': '80'}}).then(res => {
            if (res.data.body.result !== '0') {
                return;
            }
            this.providers = res.data.body.tables[0]['colvalues'];
        });
    },
    mounted() {
        this.calculateGridHeight();
        window.addEventListener('resize', this.calculateGridHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateGridHeight);
    }
}
</script>

<style lang="scss" scoped>
.aml-blockchain-grid {
    display: grid;
    gap: 16px 16px;
    overflow-y: auto;
    padding-right: 8px;
    align-content: start;
    
    /* Для экранов больше 768px: 3 колонки на всю ширину */
    @media (min-width: 769px) {
        grid-template-columns: repeat(3, 1fr);
    }
    
    /* Для экранов 768px и меньше: 2 колонки на всю ширину */
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }
    
    /* Кастомный скроллбар */
    &::-webkit-scrollbar {
        width: 6px;
        margin-left: 8px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f5f9;
        border-radius: 3px;
        margin-left: 8px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: $menu-bg;
        border-radius: 3px;
        
        &:hover {
            background: $menu-bg2;
        }
    }
    
    &::-webkit-scrollbar-button {
        display: none;
    }
}

.aml-blockchain-item {
    height: 56px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    transition: all 0.2s ease;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding: 12px;
    border: 1px solid $primary-stroke;
    border-radius: 12px;
    background-color: white;
    
    &:hover:not(.selected) {
        border-color: var(--bs-primary) !important;
        background-color: #f8fafc !important;
    }
    
    &.selected {
        border-color: $menu-bg;
        background-color: $bg-light-blue;
        color: inherit;
    }
    
    span {
        line-height: 1;
        display: flex;
        align-items: center;
    }
}

.provider-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
}

.provider-item {
    cursor: pointer;
    border: 1px solid $primary-stroke;
    border-radius: 12px;
    background-color: white;
    transition: all 0.2s ease;
    
    &:hover {
        border-color: var(--bs-primary) !important;
        background-color: #f8fafc !important;
    }
}

.provider-logo {
    width: 80px;
    height: 80px;
    object-fit: contain;
}

.blockchain-icon {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.blockchain-placeholder {
    width: 32px;
    height: 32px;
    background-color: #e5e7eb;
    border-radius: 50%;
    flex-shrink: 0;
}

.aml-result-message {
    width: 100%;
    padding: 16px;
    border: 1px solid $color-notification;
    border-radius: 8px;
    background-color: #F3FFF6;
    color: $color-notification;
    
    &.error {
        border-color: $color-invalid;
        background-color: #FFF5F5;
        color: $color-invalid;
    }
    
    .me-2 {
        margin-right: 10px;
    }
}

.progress-circle-container {
    position: relative;
    width: 257px;
    height: 153px;
    margin-bottom: 16px;
}

/* .progress-circle - поворот убран, дуга правильно ориентирована */

.progress-arc {
    transition: stroke-dashoffset 0.5s ease-in-out, stroke 0.3s ease-in-out;
}

.progress-text {
    position: absolute;
    top: calc(84% - 15px);
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}

.progress-percentage {
    font-size: 56px;
    font-weight: 600;
    transition: color 0.3s ease-in-out;
}

.progress-labels {
    position: absolute;
    bottom: 8px;
    left: 0;
    right: 0;
}

.label-start {
    position: absolute;
    left: 25px;
    transform: translateX(-50%);
    font-size: 14px;
    color: #64748b;
    font-family: 'Neue', sans-serif;
}

.label-end {
    position: absolute;
    right: 25px;
    transform: translateX(50%);
    font-size: 14px;
    color: #64748b;
    font-family: 'Neue', sans-serif;
}

.risk-text {
    text-align: center;
    line-height: 28px;
    font-family: 'Neue', sans-serif;
    font-weight: 500;
    transition: color 0.3s ease-in-out;
}

.progress-container {
    margin-top: 64px;
}

.btn-container {
    display: flex;
    gap: 16px;
    position: absolute;
    bottom: 24px;
    left: 24px;
    right: 24px;
}


.check-another-btn {
    margin: 0;
}
</style>
